export enum ProjectStatusEnum {
    DRAFT = 0,
    REQUEST = 1,
    IN_PROCESS = 2,
    QUOTE_SENT = 3,
    REJECTED = 4,
    PROJECT_WON = 5,
    DELETED = 6,
    QUOTE_SENT_MANUALLY = 7,
    PROJECT_LOST
}
